import React, { Component } from "react";
import ReactMarkdown from "react-markdown";
import PropTypes from "prop-types";

import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import styles from "./Contact.module.css";
import StoreField from "./StoreField/StoreField";
import PhoneWidget from "../../components/PhoneWidget/PhoneWidget";
import * as phoneService from "../../shared/utilities/phone";

import messages from "../../shared/constants/messages";
import { handleFormInput } from "../../shared/utilities/validations";
import { customerHelpSectionKeys, customerHelpSettings } from "../../shared/constants/contactTabs";
import OrderFeedbackFormSubmited from "../../components/FeedbackForm/OrderFeedbackFormSubmited";

import * as contactRepo from "../../shared/repos/graphql/contact";
import * as siteSettingRepo from '../../shared/repos/graphql/siteSetting';
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';

const submitImage = require("./imgs/submit.png");
const trashImage = require("./imgs/trash.png");
const uploadImage = require("./imgs/upload.png");

class CustomerHelp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: "",
      errorMessage: null,
      orderNumber: "",
      fullName: "",
      email: "",
      phone: "",
      phoneData: {},
      renderForm: null,
      formType: "Feedback",
      file: null,
      settings: [],
      renderAfterSubmitContent: false,
      formValid: false,
      formSubmitted: false,
      activeSection: undefined,
      store: null,
    };
    this.activeIndexCheck = null;
  }

  componentDidMount = async () => {
    const { sectionId } = this.props
    const siteSettingKeys = customerHelpSettings.map(item => item.siteSetting);
    const response = await siteSettingRepo.getSiteSettings(
      siteSettingKeys
    );
    let settingsData = [];
    if (response?.data?.siteSettings) {
      settingsData = customerHelpSettings.filter(item => {
        const setting = response?.data?.siteSettings.find(
          i => i.name === item.siteSetting && i.value === "1"
        );
        return !!setting;
      });
      this.setState({ settings: settingsData });
    }

    const key = decodeURIComponent(sectionId).toLowerCase();
    let activeSection;
    if (key) {
      activeSection = customerHelpSettings.find(item => item.key === key);
    }
    if (!activeSection) {
      activeSection = settingsData[0] ?? undefined;
    }

    if (activeSection) {
      this.onDropdownChange(activeSection.key);
    }
  };

  renderInput = (
    component,
    label,
    state,
    isTextArea,
    validationType = "string",
    inputMask = "",
    errorMessage = null
  ) => {
    const text = component.state[state];

    return (
      <Input
        isTextArea={isTextArea}
        theme="dark"
        customContainerStyles={styles.inputWrapper}
        handleInput={(e) => {
          handleFormInput(e, component, state, validationType, errorMessage);
          component.checkFormValidity();
        }}
        placeholder=" "
        value={text}
        label={label}
        inputMask={inputMask}
      />
    );
  };

  renderTextArea = (component, label = "Description...") => {
    const { comment } = component.state;
    return (
      <div>
        <Input
          isTextArea
          theme="dark"
          customContainerStyles={styles.textareaWrapper}
          handleInput={(e) => {
            if (e.target.value.length <= 1000) {
              handleFormInput(e, component, "comment");
            }
            component.checkFormValidity();
          }}
          placeholder=" "
          value={comment}
          label={label}
        />
        <span className="text-[#745881] text-base leading-5 font-montserratMedium font-medium">{`${comment.length}/1000 Characters`}</span>
      </div>
    );
  };

  onUploadFile = ({ target: { files } }) => {
    const file = files[0];
    this.setState({ file }, () => this.checkFormValidity());
  };

  renderFileInput = (title, name) => {
    const { file } = this.state;
    return (
      <div className="mt-3 w-full">
        {/* eslint-disable-next-line */}
        <label className="block mb-2 text-base font-bold text-dark dark:text-white font-montserratBold">
          {title}
        </label>
  
        <div className="flex items-center gap-3">
          {/* Custom File Button */}
          <label
            htmlFor={name}
            className="flex items-center gap-2 px-4 py-2 border border-dark text-dark rounded-full cursor-pointer hover:bg-purple-50 transition-colors duration-200"
          >
            <img src={uploadImage} alt="" />
            <span className="font-montserratMedium font-medium text-base text-dark dark:text-white">Choose File</span>
            <input
              id={name}
              name={name}
              type="file"
              onChange={this.onUploadFile}
              className="hidden"
            />
          </label>
  
          {/* File name + delete */}
          {file ? (
            <div className="flex items-center gap-2 text-dark font-montserratMedium font-medium text-base leading-5">
              <span className="truncate max-w-[180px]">{file.name}</span>
              <button
                type="button"
                onClick={() => this.setState({ file: null })}
                className="bg-transparent"
                title="Remove file"
              >
                <img src={trashImage} alt="" />
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-2 text-[#745881] font-montserratMedium font-medium text-base leading-5">
              <span className="truncate max-w-[180px]">{isBrandRefreshEnabled() ? 'No file chosen' : 'No file choosen'}</span>
            </div>
          )}
        </div>
      </div>
    );
  };

  renderSubmitButton = () => {
    const { formValid, formSubmitted } = this.state;
    return (
      <div className="md:flex gap-4 w-full">
        <Button
          handleSubmit={this.handleSubmit}
          customContainerStyles={`${styles.submitButton} ${formValid ? '' : styles.disabledButton}`}
          disabled={!formValid || formSubmitted}
          label={(
            <div className="flex items-center justify-center gap-2">
              <img src={submitImage} alt="" />
              {!formValid ? 'Complete required fields to Submit' : 'Submit'}
            </div>
        )}
        />      
      </div>
    )
  };

  renderFeedbackOptions = settings => {
    const { activeSection } = this.state;
    const refreshed = isBrandRefreshEnabled();
    const OptionControl = refreshed ? 'button' : 'div';
    const OptionLabel = refreshed ? 'span' : 'div';
    return (
      <div
        className="
          flex flex-row md:flex-col lg:flex-col 
          gap-4 
          w-[360px] lg:min-w-[260px] lg:w-auto
          overflow-x-auto md:overflow-visible
          scrollbar-hide
          [-ms-overflow-style:none] [scrollbar-width:none]
          mb-2 lg:mb-0
        "
      >
        {settings.map(setting => (
          <OptionControl
            key={setting.key}
            type={refreshed ? 'button' : undefined}
            role={refreshed ? undefined : 'button'}
            data-part={refreshed ? 'report-option' : undefined}
            aria-pressed={refreshed ? activeSection?.key === setting.key : undefined}
            tabIndex="0"
            onKeyPress={refreshed ? undefined : e => e.key === "Enter" && this.onDropdownChange(setting.key)}
            onClick={() => this.onDropdownChange(setting.key)}
            className="flex-shrink-0 lg:flex text-center"
          >
            <OptionLabel
              className={` text-center ${
                activeSection?.key === setting.key
                  ? "bg-dark text-white dark:bg-button dark:text-white font-bold"
                  : "text-dark font-medium"
              } px-3 py-3 font-montserratBold text-base leading-5 tracking-normal rounded-md`}
            >
              {setting.title}
            </OptionLabel>
          </OptionControl>
        ))}

      </div>
    );
  };

  onDropdownChange = key => {
    let renderForm = null;
    const { activeSection } = this.state;
    if (activeSection?.key === key) {
      return;
    }
    switch (key) {
      case customerHelpSectionKeys.DELIVERY_EXPERIENCE:
        renderForm = this.renderOrderInqueryForm;
        break;
      case customerHelpSectionKeys.WEBSITE_APP_FEEDBACK:
        renderForm = this.renderAppFeedbackForm;
        break;
      case customerHelpSectionKeys.IN_STORE_EXPERIENCE:
        renderForm = this.renderInStoreExperience;
        break;
      case customerHelpSectionKeys.FOOD_SAFETY:
        renderForm = this.renderInStoreExperience;
        break;
      case customerHelpSectionKeys.SAFETY_INCIDENT:
        renderForm = this.renderInStoreExperience;
        break;
      case customerHelpSectionKeys.GIFT_CARD_INQUIRY:
        renderForm = this.renderGiftcardInqueryForm;
        break;
      case customerHelpSectionKeys.TAX_EXEMPT_INQUIRY:
        renderForm = this.renderTaxExemptInqueryForm;
        break;
      case customerHelpSectionKeys.SOMETHING_ELSE:
        renderForm = this.renderOtherInqueryForm;
        break;
      default:
        break;
    }
    const section = customerHelpSettings.find(item => item.key === key);
    this.setState({
      activeSection: section,
      renderForm
    }, () => this.resetFormFields(this.checkFormValidity));
  };

  onStoreChange = (store) => {
    this.setState({ store }, this.checkFormValidity);
  }

  renderOrderInqueryForm = () => {
    const { phoneErrorMessage, store, phone} = this.state;
    const code = phoneService.detectCountryCode(phone ?? "");
    const phoneNumber = phoneService.detectPhone(phone ?? "");
    const { consentSmsContent } = this.props;
    return (
      <div className="-mt-4">
        {this.renderInput(this, "First & Last Name*", "fullName")}
        {this.renderInput(this, "Email*", "email", false, "email")}
        <div className={styles.phoneWidget}>
          <PhoneWidget
            onInput={(fieldName, e) => {
              this.setState({
                phone: e.telephone,
                phoneData: e
              });
            }}
            fieldName="phoneNumber"
            label="Mobile number"
            errorMessage={phoneErrorMessage}
            telephone={phone}
            code={code}
            phone={phoneNumber}
            theme="light"
          />
        </div>
        {this.renderInput(this, "Order#*", "orderNumber")}

        <StoreField onChange={this.onStoreChange} store={store} isRequired prompt="No specific bakery" promptValue="0" />
        {this.renderTextArea(this, "Description*")}
        {this.renderFileInput("Upload File", "file")}

        <div
          className={`${styles.smsConsentText} !text-darkElevationPrimary dark:!text-darkElevationSecondary`}
        >
          <ReactMarkdown>{consentSmsContent}</ReactMarkdown>
        </div>
        {this.renderSubmitButton()}
      </div>
    );
  };

  renderAppFeedbackForm = () => {
    const { phoneErrorMessage, phone, store } = this.state;
    const code = phoneService.detectCountryCode(phone ?? "");
    const phoneNumber = phoneService.detectPhone(phone ?? "");
    const { consentSmsContent } = this.props;
    return (
      <div className="-mt-4">
        {this.renderInput(this, "First & Last Name*", "fullName")}
        {this.renderInput(this, "Email*", "email", false, "email")}
        <div className={styles.phoneWidget}>
          <PhoneWidget
            onInput={(fieldName, e) => {
              this.setState({
                phone: e.telephone,
                phoneData: e
              });
            }}
            fieldName="phoneNumber"
            label="Mobile number"
            errorMessage={phoneErrorMessage}
            telephone={phone}
            code={code}
            phone={phoneNumber}
            theme="light"
          />
        </div>
        {this.renderInput(this, "Order#", "orderNumber")}

        <StoreField store={store} onChange={this.onStoreChange} />

        {this.renderTextArea(this, "Description*")}
        {this.renderFileInput("Upload File", "file")}

        <div
          className={`${styles.smsConsentText} !text-darkElevationPrimary dark:!text-darkElevationSecondary`}
        >
          <ReactMarkdown>{consentSmsContent}</ReactMarkdown>
        </div>

        {this.renderSubmitButton()}
      </div>
    );
  };

  renderInStoreExperience = () => {
    const { phoneErrorMessage, phone, store } = this.state;
    const code = phoneService.detectCountryCode(phone ?? "");
    const phoneNumber = phoneService.detectPhone(phone ?? "");
    const { consentSmsContent } = this.props;
    return (
      <div className="-mt-4">
        {this.renderInput(this, "First & Last Name*", "fullName")}
        {this.renderInput(this, "Email*", "email", false, "email")}
        <div className={styles.phoneWidget}>
          <PhoneWidget
            onInput={(fieldName, e) => {
              this.setState({
                phone: e.telephone,
                phoneData: e
              });
            }}
            fieldName="phoneNumber"
            label="Mobile number"
            errorMessage={phoneErrorMessage}
            telephone={phone}
            code={code}
            phone={phoneNumber}
            theme="light"
          />
        </div>

        <StoreField onChange={this.onStoreChange} store={store} isRequired />

        {this.renderTextArea(this, "Description*")}
        {this.renderFileInput("Upload File", "file")}

        <div
          className={`${styles.smsConsentText} !text-darkElevationPrimary dark:!text-darkElevationSecondary`}
        >
          <ReactMarkdown>{consentSmsContent}</ReactMarkdown>
        </div>

        {this.renderSubmitButton()}
      </div>
    );
  };

  renderGiftcardInqueryForm = () => {
    const { phoneErrorMessage, phone, store } = this.state;
    const code = phoneService.detectCountryCode(phone ?? "");
    const phoneNumber = phoneService.detectPhone(phone ?? "");
    const { consentSmsContent } = this.props;
    return (
      <div className="-mt-4">
        {this.renderInput(this, "First & Last Name*", "fullName")}
        {this.renderInput(this, "Email*", "email", false, "email")}
        <div className={styles.phoneWidget}>
          <PhoneWidget
            onInput={(fieldName, e) => {
              this.setState({
                phone: e.telephone,
                phoneData: e
              });
            }}
            fieldName="phoneNumber"
            label="Mobile number"
            errorMessage={phoneErrorMessage}
            telephone={phone}
            code={code}
            phone={phoneNumber}
            theme="light"
          />
        </div>
        {this.renderInput(this, "Order#", "orderNumber")}
        {this.renderInput(this, "Giftcard#*", "giftcardNumber")}
        {this.renderInput(this, "Giftcard Amount*", "giftcardAmount")}
        {this.renderInput(
          this,
          "Recipient's Email",
          "recipientEmail",
          false,
          "email",
          "",
          "Wrong Recipient's Email format",
        )}
        <StoreField onChange={this.onStoreChange} store={store} isRequired prompt="No specific bakery" promptValue="0" />
        {this.renderTextArea(this, "Description*")}
        {this.renderFileInput("Upload File", "file")}

        <div
          className={`${styles.smsConsentText} !text-darkElevationPrimary dark:!text-darkElevationSecondary`}
        >
          <ReactMarkdown>{consentSmsContent}</ReactMarkdown>
        </div>

        {this.renderSubmitButton()}
      </div>
    );
  };

  renderTaxExemptInqueryForm = () => {
    const { phoneErrorMessage, phone, store } = this.state;
    const code = phoneService.detectCountryCode(phone ?? "");
    const phoneNumber = phoneService.detectPhone(phone ?? "");
    const { consentSmsContent } = this.props;
    return (
      <div className="-mt-4">
        {this.renderInput(this, "First & Last Name*", "fullName")}
        {this.renderInput(this, "Email*", "email", false, "email")}
        {this.renderInput(
          this,
          "Rewards Account Email (if different)",
          "rewardAccountEmail",
          false,
          "email",
          "",
          "Wrong Rewards Account Email format",
        )}
        <div className={styles.phoneWidget}>
          <PhoneWidget
            onInput={(fieldName, e) => {
              this.setState({
                phone: e.telephone,
                phoneData: e
              });
            }}
            fieldName="phoneNumber"
            label="Mobile number"
            errorMessage={phoneErrorMessage}
            telephone={phone}
            code={code}
            phone={phoneNumber}
            theme="light"
          />
        </div>
        {this.renderInput(this, "Order#", "orderNumber")}
        <StoreField onChange={this.onStoreChange} store={store} isRequired prompt="No specific bakery" promptValue="0" />
        {this.renderTextArea(this, "Description*")}
        {this.renderFileInput("Upload Tax Exempt Documents*", "file")}

        <div
          className={`${styles.smsConsentText} !text-darkElevationPrimary dark:!text-darkElevationSecondary`}
        >
          <ReactMarkdown>{consentSmsContent}</ReactMarkdown>
        </div>

        {this.renderSubmitButton()}
      </div>
    );
  };

  renderOtherInqueryForm = () => {
    const { phoneErrorMessage, phone, store } = this.state;
    const code = phoneService.detectCountryCode(phone ?? "");
    const phoneNumber = phoneService.detectPhone(phone ?? "");
    const { consentSmsContent } = this.props;
    return (
      <div className="-mt-4">
        {this.renderInput(this, "First & Last Name*", "fullName")}
        {this.renderInput(this, "Email*", "email", false, "email")}
        <div className={styles.phoneWidget}>
          <PhoneWidget
            onInput={(fieldName, e) => {
              this.setState({
                phone: e.telephone,
                phoneData: e
              });
            }}
            fieldName="phoneNumber"
            label="Mobile number"
            errorMessage={phoneErrorMessage}
            telephone={phone}
            code={code}
            phone={phoneNumber}
            theme="light"
          />
        </div>
        {this.renderInput(this, "Order#", "orderNumber")}
        <StoreField onChange={this.onStoreChange} store={store} isRequired prompt="No specific bakery" promptValue="0" />
        {this.renderTextArea(this, "Description*")}

        {this.renderFileInput("Upload File", "file")}
        <div
          className={`${styles.smsConsentText} !text-darkElevationPrimary dark:!text-darkElevationSecondary`}
        >
          <ReactMarkdown>{consentSmsContent}</ReactMarkdown>
        </div>
        {this.renderSubmitButton()}
      </div>
    );
  };

  handleSubmit = () => {
    const {
      formType,
      orderNumber,
      fullName,
      email,
      phone,
      store,
      comment,
      organizationName,
      eventLocation,
      eventDate,
      eventType,
      proposedLocation,
      productName,
      productCost,
      phoneData,
      activeSection,
      giftcardNumber,
      giftcardAmount,
      recipientEmail,
      rewardAccountEmail,
      file
    } = this.state;
    this.setState({ errorMessage: null, formSubmitted: true });
    let formValidated = false;
    switch (activeSection?.key) {
      case customerHelpSectionKeys.DELIVERY_EXPERIENCE:
        formValidated = this.validateOrderInquiryForm();
        break;
      case customerHelpSectionKeys.WEBSITE_APP_FEEDBACK:
        formValidated = this.validateAppFeedbackForm();
        break;
      case customerHelpSectionKeys.IN_STORE_EXPERIENCE:
        formValidated = this.validateInStoreForm();
        break;
      case customerHelpSectionKeys.FOOD_SAFETY:
        formValidated = this.validateInStoreForm();
        break;
      case customerHelpSectionKeys.SAFETY_INCIDENT:
        formValidated = this.validateInStoreForm();
        break;
      case customerHelpSectionKeys.GIFT_CARD_INQUIRY:
        formValidated = this.validateGiftcardForm();
        break;
      case customerHelpSectionKeys.TAX_EXEMPT_INQUIRY:
        formValidated = this.validateTaxExemptInqueryForm();
        break;
      case customerHelpSectionKeys.SOMETHING_ELSE:
        formValidated = this.validateOtherInqueryForm();
        break;
      default:
        break;
    }

    if (phoneData.phone && phoneData.maskValidation === false) {
      window.scrollTo(0, 0); // eslint-disable-line
      return this.setState({
        errorMessage: messages.phoneInput.maskValidation.replace(
          "%s",
          phoneData.mask
        ),
        formSubmitted: false
      });
    }

    if (formValidated) {
      return contactRepo
        .submitContactForm({
          formType,
          orderNumber,
          fullName,
          email,
          phone,
          store,
          comment,
          organizationName,
          eventLocation,
          eventDate,
          eventType,
          proposedLocation,
          productName,
          productCost,
          subject: activeSection?.title ?? "",
          formKey: activeSection?.key ?? "",
          giftcardNumber,
          giftcardAmount,
          recipientEmail,
          rewardAccountEmail,
          file
        })
        .then(() => {
          window.scrollTo(0, 0); // eslint-disable-line
          this.setState({
            renderAfterSubmitContent: true,
            formSubmitted: false
          }); // eslint-disable-line
          this.resetFormFields(this.checkFormValidity);
        })
        .catch(error => {
          const message = error?.graphQLErrors?.[0]?.message ?? 'Something went wrong';
          window.scrollTo(0, 0); // eslint-disable-line
          this.setState({ errorMessage: message, formSubmitted: false }); // eslint-disable-line
        });
    }

    this.setState({ formSubmitted: false });
    return false;
  };

  resetFormFields = (callback) => {
    this.setState({
      orderNumber: "",
      fullName: "",
      email: "",
      phone: "",
      store: null,
      comment: "",
      organizationName: "",
      eventLocation: "",
      eventDate: "",
      eventType: "",
      proposedLocation: "",
      productName: "",
      productCost: "",
      phoneData: "",
      giftcardNumber: "",
      giftcardAmount: "",
      recipientEmail: "",
      rewardAccountEmail: "",
      errorMessage: null,
      file: null
    }, callback || (() => {}));
  };

  checkFormValidity = () => {
    const { activeSection } = this.state;
    let formValidated = false;
  
    switch (activeSection?.key) {
      case customerHelpSectionKeys.DELIVERY_EXPERIENCE:
        formValidated = this.validateOrderInquiryForm();
        break;
      case customerHelpSectionKeys.WEBSITE_APP_FEEDBACK:
        formValidated = this.validateAppFeedbackForm();
        break;
      case customerHelpSectionKeys.IN_STORE_EXPERIENCE:
      case customerHelpSectionKeys.FOOD_SAFETY:
      case customerHelpSectionKeys.SAFETY_INCIDENT:
        formValidated = this.validateInStoreForm();
        break;
      case customerHelpSectionKeys.GIFT_CARD_INQUIRY:
        formValidated = this.validateGiftcardForm();
        break;
      case customerHelpSectionKeys.TAX_EXEMPT_INQUIRY:
        formValidated = this.validateTaxExemptInqueryForm();
        break;
      case customerHelpSectionKeys.SOMETHING_ELSE:
        formValidated = this.validateOtherInqueryForm();
        break;
      default:
        formValidated = false;
        break;
    }
    this.setState({ formValid: !!formValidated });
  };
  

  validateOrderInquiryForm = () => {
    const {
      fullName,
      email,
      orderNumber,
      comment,
      store
    } = this.state;

    if (
      !email ||
      !fullName ||
      !orderNumber ||
      !comment ||
      store === null
    ) {
      return false;
    }

    return true;
  };

  validateAppFeedbackForm = () => {
    const { fullName, email, comment } = this.state;

    if (!email || !fullName || !comment) {
      return false;
    }

    return true;
  };

  validateInStoreForm = () => {
    const { fullName, email, comment, store } = this.state;
    if (!email || !fullName || !comment || store === null) {
      return false;
    }

    return true;
  };

  validateGiftcardForm = () => {
    const {
      fullName,
      email,
      giftcardNumber,
      giftcardAmount,
      comment,
      store
    } = this.state;

    if (
      !email ||
      !fullName ||
      !giftcardNumber ||
      !giftcardAmount ||
      !comment ||
      store === null
    ) {
      return false;
    }

    return true;
  };

  validateTaxExemptInqueryForm = () => {
    const { fullName, email, comment, file, store } = this.state;

    if (!email || !fullName || !comment || store === null || !file) {
      return false;
    }

    return true;
  };

  validateOtherInqueryForm = () => {
    const { fullName, email, comment, store } = this.state;

    if (!email || !fullName || !comment || store === null) {
      return false;
    }

    return true;
  };

  onSuccessClose = () => {
    const { activeSection } = this.state;
    this.setState({ renderAfterSubmitContent: false });
    this.onDropdownChange(activeSection?.key);
  };

  renderContactUsContent = () => {
    const {
      errorMessage,
      successMessage,
      renderForm,
      settings
    } = this.state;

    return (
      <div
        className={`${styles.formContainer} flex flex-col lg:flex-row gap-4`}
      >
        <div className="flex flex-col gap-4 w-full lg:min-w-[260px] lg:w-auto">
          {this.renderFeedbackOptions(settings)}
        </div>
        <div className="flex flex-col w-full lg:w-[720px]">
          <span
            className={[
              errorMessage ? styles.error : null,
              successMessage ? styles.success : null
            ].join(" ")}
          >
            {errorMessage || successMessage}
          </span>
          <form>
            {renderForm && renderForm()}
          </form>
        </div>
      </div>
    );
  };

  renderFeedbackFormSubmited = () => {
    return (
      <OrderFeedbackFormSubmited
        onClose={this.onSuccessClose}
        className={[
          `text-dark dark:text-white`,
          styles.feedbackFormSubmitedContainer
        ].join(" ")}
      />
    );
  };

  render() {
    const { renderAfterSubmitContent } = this.state;

    return renderAfterSubmitContent
      ? this.renderFeedbackFormSubmited()
      : this.renderContactUsContent();
  }
}

CustomerHelp.propTypes = {
  sectionId: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([undefined])]),
  consentSmsContent: PropTypes.string,
};

CustomerHelp.defaultProps = {
  sectionId: undefined,
  consentSmsContent: "",
};

export default CustomerHelp;
